<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebarf">
<p class="fm01"><em class="italic">Front cover. At top: Sungjun Jang’s Pzkpfw III ausf J in 1/35 scale built and painted to represent a vehicle of 3.Kompanie, Panzer-Regiment 8. The photographs in the centre depict, from left to right, a Pzkpfw III ausf G of 2.Kompanie, Panzer-Regiment 5 being unloaded in Tripoli in March 1941. A Pzkpfw III ausf J of 5.Kompanie, Panzer-Regiment 8 pictured in mid-1942. A Panzerbefehlswagen III ausf E from the headquarters of I.Abteilung, Panzer-Regiment 8 photographed in late 1941. The illustration at the foot of the page depicts a Pzkpfw III ausf H of 6.Kompanie, Panzer-Regiment 8. The colours used on these tanks are discussed in detail in the Camouflage &amp; Markings and Technical Details and Modifications sections of this book</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm02.vue?63af3d62